import React, { useState, useEffect } from 'react';
import { Select } from 'semantic-ui-react';
function SelectStatus({statusProps,hashProps,changeStatusPedido,arr}){
    const [status,setStatus] = useState(false);
    const [loading,setLoading] = useState(true);

    useEffect(()=>{
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 500);
        setStatus(statusProps)
    },[statusProps,hashProps])

    useEffect(()=>{
        setLoading(false)
    },[])
    
    return (
        loading
            ?<div class="ui segment">
            <p></p>
            <div class="ui active dimmer">
                <div class="ui small loader"></div>
            </div>
            </div>
            :<Select
                style={{pointerEvents:!status === 0?'none':'auto'}}
                disabled={!status === 0}
                defaultValue={ status == 0?"1":status==70?"3":"2"}
                onChange={(e, f) => changeStatusPedido(f.value,arr)}
                options={
                [
                { key: "1", value: "1", text: "Pago" },
                { key: "2", value: "2", text: "Estornado" },
                { key: "3", value: "3", text: "Não pago" },
                ] 
            }></Select>
        
    )
}

export default SelectStatus;